export { default } from './DownloadPdf';



// WEBPACK FOOTER //
// ./src/components/DownloadPdf/index.js